import React from 'react'
import { PageLink as Link } from 'src/app/AppAuth/PageLink'

export type ExternalLinkProps = React.PropsWithChildren<{
  to: string
}>

export const ExternalLink = ({
  to,
  children,
}: ExternalLinkProps): JSX.Element => {
  return (
    <Link target="_blank" rel="noreferrer" to={to}>
      {children}
    </Link>
  )
}
